function Mymap() {
    return(
        <div>Mymap</div>
    )
}

export default Mymap;